import { createRouter, createWebHistory, type RouteLocationNormalized } from 'vue-router';
import FeedView from '@/views/FeedView.vue';
import ProfileView from '@/views/ProfileView.vue';
import ThreadView from '@/views/ThreadView.vue';
import BookmarkView from '@/views/BookmarkView.vue';
import ListView from '@/views/ListView.vue';
import NotesView from '@/views/NotesView.vue';
import AboutView from '@/views/AboutView.vue';
import FAQView from '@/views/FAQView.vue';
import TOSView from '@/views/TOSView.vue';
import BlocklistView from '@/views/BlocklistView.vue';
import ContactView from '@/views/ContactView.vue';
import EventsView from '@/views/EventsView.vue';
import AdminStudiosView from '@/views/AdminStudiosView.vue';
import StudiosView from '@/views/StudiosView.vue';
import AdminPinnedInfoView from '@/views/AdminPinnedInfoView.vue';
import TimelineView from '@/views/TimelineView.vue';
import AdminAdsView from '@/views/AdminAdsView.vue';
import ChangelogView from '@/views/ChangelogView.vue';

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

const routes = [
  {
    path: '/',
    name: 'Home',
    component: FeedView
  },
  {
    path: '/curated',
    name: 'Curated',
    component: FeedView
  },
  {
    path: '/t/:tag',
    name: 'TagFeed',
    component: FeedView
  },
  {
    path: '/search',
    name: 'Search',
    component: FeedView,
    props: (route: RouteLocationNormalized) => ({ q: route.query.q })
  },
  {
    path: '/profile/:handle([a-zA-Z0-9.:-]+)',
    name: 'Profile',
    component: ProfileView,
    props: true
  },
  {
    path: '/profile/:handle([a-zA-Z0-9.:-]+)/post/:rkey',
    name: 'Thread',
    component: ThreadView,
    props: true
  },
  {
    path: '/profile/:handle([a-zA-Z0-9.:-]+)/note/:rkey?',
    name: 'Note',
    component: NotesView,
    props: true
  },
  {
    path: '/bookmarks',
    name: 'Bookmarks',
    component: BookmarkView
  },
  {
    path: '/lists',
    name: 'Lists',
    component: ListView
  },
  {
    path: '/what-is',
    name: 'WhatIs',
    component: AboutView
  },
  {
    path: '/faq',
    name: 'FAQ',
    component: FAQView
  },
  {
    path: '/tos',
    name: 'TOS',
    component: TOSView
  },
  {
    path: '/blocklist',
    name: 'Blocklist',
    component: BlocklistView
  },
  {
    path: '/contact',
    name: 'Contact',
    component: ContactView
  },
  {
    path: '/events',
    name: 'Events',
    component: EventsView
  },
  {
    path: '/timeline',
    name: 'Timeline',
    component: TimelineView
  },
  {
    path: '/studios',
    name: 'Studios',
    component: StudiosView
  },
  {
    path: '/admin/studios',
    name: 'AdminStudios',
    component: AdminStudiosView
  },
  {
    path: '/admin/pinned',
    name: 'AdminPinned',
    component: AdminPinnedInfoView
  },
  {
    path: '/admin/ads',
    name: 'AdminAds',
    component: AdminAdsView
  },
  {
    path: '/changelog',
    name: 'Changelog',
    component: ChangelogView
  }
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  }
});

// Google Analytics Navigation Guard
router.afterEach((to) => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'page_view', {
      page_title: to.name as string,
      page_location: window.location.href,
      page_path: to.fullPath
    });
  }
});

export default router;
